import { useField } from 'formik';
import { SyntheticEvent, memo, useState } from 'react';
import { useLatest } from 'react-use';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { InterviewLanguage, Question } from '@synergetx/puppet-interview-types';

import QuestionFieldSet from './QuestionFieldSet';

type Props = {
    position: number;
};

const LanguageTabs = ({ position }: Props) => {
    const [{ value: languages }] = useField<InterviewLanguage[]>(`languages`);
    const [{ value: question }] = useField<Question>(`questions[${position}]`);
    const [language, setLanguage] = useState<InterviewLanguage>(languages[0]);

    const handleChange = useLatest((event: SyntheticEvent, newLanguage: InterviewLanguage) => {
        event.stopPropagation();
        setLanguage(newLanguage);
    }).current;

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            {languages.length > 1 ? (
                <TabContext value={language}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                            {languages.map((language) => (
                                <Tab label={`${language}`} value={`${language}`} key={language} />
                            ))}
                        </TabList>
                    </Box>
                    {languages.map((language) => (
                        <TabPanel
                            value={`${language}`}
                            key={language}
                            sx={{ paddingX: 0, paddingBottom: 0, paddingTop: 2 }}
                        >
                            <QuestionFieldSet
                                position={position}
                                language={language}
                                type={question.type}
                            />
                        </TabPanel>
                    ))}
                </TabContext>
            ) : (
                <QuestionFieldSet
                    position={position}
                    language={languages[0]}
                    type={question.type}
                />
            )}
        </Box>
    );
};

export default memo(LanguageTabs);
